/**
* Created by kongwm.kong on 2017/7/25.
*/
<template>
    <div class="fund-table-wrap">
        <table :class="{'fund-table': true, 'table1':isJoined ==2}">
            <thead>
            <tr>
<!--                <th class="th1">操作</th>-->
                <th class="th2">基金ID</th>
                <th class="th3">基金简称</th>
                <th  class="th4">单位净值</th>
                <th class="th5">净值日期</th>
                <th  class="th6">累计净值</th>
                <th class="th7">复权净值</th>
                <th  class="th8">单位面值</th>
                <th  class="th9">更新日期</th>
                <th  class="th10">审核状态</th>
                <th  class="th11">审核意见</th>
            </tr>
            </thead>
            <tbody v-show="!noDataShow">
            <tr v-for="(item , index) in listData">
<!--                <td class="th1"><router-link :to="{name: 'netDetail', params: {id: item.id, type: isJoined},query:{data: JSON.stringify(item)}}" >编辑</router-link></td>-->
                <td class="th2">{{item.productCode}}</td>
                <td class="th3">{{item.productName}}</td>
                <td class="th4">{{item.unitNet}}</td>
                <td class="th5">{{item.pubDate | setTime('yyyy-mm-dd')}}</td>
                <td class="th6">{{item.accNet}}</td>
                <td class="th7">{{item.adjustedNet}}</td>
                <td class="th8">{{item.initialUnitValue}}</td>
                <td class="th9">{{item.updateTime | setTime('yyyy-mm-dd')}}</td>
                <td  class="th10">{{item.auditStatus | getAuditStatus}}</td>
                <td  class="th11">{{item.auditComment}}</td>
            </tr>
            </tbody>
        </table>
        <div class="page_wrap" v-show="!noDataShow && showPage">
            <paginate
                :pageCount="pageCount"
                :containerClass="'pagination'"
                :clickHandler="changePage"
                :pageRange="5"
                :marginPages="1"
                :prevText="'&lt;'"
                :nextText="'&gt;'"
                :initialPage="initialPage"
                :pageClass="'page-item'"
            ></paginate>
            <page-jump :showPage="showPageJump" @pageJump="pageJump" :pageNum="getPageJumpNum"></page-jump>
        </div>
        <!--无数据-->
        <no-data :noDataShow="noDataShow"></no-data>
    </div>
</template>
<script>
//    import Paginate from 'vuejs-paginate'
    import Paginate from '../../components/middleware/Paginate'
    import noData from '../../components/common/noData';
    import pageJump from '../../components/middleware/page-jump'
    export default {
        props: {
            isJoined:{
                required: true
            },
            noParams:{  //不加后面的参数
                type: Boolean,
                default: true
            },
            isSearch:{},
            netName:{},
            dateStart:{},
            dateEnd:{}
        },
        components:{
            Paginate,
            noData,
            pageJump
        },
        data(){
            return{
                noDataShow: false,
                showPage:false,
                currPage: 1,
                listData: [],
                pageCount: 0,
                orderBy: '',
                showPageJump: false,
                pageJumpNum: 5,
            }
        },
        mounted(){
            this.$store.commit('getLoginInfo', this.getJoined);
//            this.getJoined();
        },
        computed:{
            getPageJumpNum(){
                if( this.pageCount > 5 ){
                    this.showPageJump = true;
                    this.pageJumpNum = Math.ceil(this.currPage / 5) * 5;
                    if(this.pageJumpNum > this.pageCount){
                        this.pageJumpNum = this.pageCount;
                    }else if(this.currPage == this.pageJumpNum &&this.pageJumpNum + 5 <  this.pageCount){
                        this.pageJumpNum = this.pageJumpNum + 5;
                    }
                } else {
                    this.showPageJump = false;
                }
                return  this.pageJumpNum;
            },
            initialPage(){
                return  this.currPage-1;
            }
        },
        methods:{
            getJoined(){
                let flag = 'report';
                if(this.isJoined == 1){ //已加入
                    flag = 'result';
                }
                this.getCompanyList(flag);
            },
            /*请求list*/
            getCompanyList(flag){
                let url = `/networth/${flag}/page?pageNo=${this.currPage}&pageSize=10`;
                if(this.netName && this.netName!='' && !this.noParams){
                    url += `&productShortName=${this.netName}`;
                }
                if(this.dateStart  && !this.noParams){
                    let date = new Date(this.dateStart);
                    let dateStart = date.getTime();
                    url += `&fromDate=${dateStart}`
                }
                if(this.dateEnd  && !this.noParams){
                    let date = new Date(this.dateEnd);
                    let dateEnd = date.getTime();
                    url += `&toDate=${dateEnd}`
                }
                this.$http.request({
                    url: url
                }, response => {
                    let data =  response.data;
                    if(data.code===200){
                        let listData = data.data;
                        if(listData.total && listData.list && listData.list.length){
                            this.listData = listData.list;
                            this.pageCount = Math.ceil(listData.total/ 10);
                            if(this.pageCount<2){
                                this.showPage = false;
                            } else {
                                this.showPage = true;
                            }
                            this.noDataShow = false;
                        } else {
                            this.noDataShow = true;
                        }
                    }else {
                        this.noDataShow = true;
                    }
                }, err => {
                    this.noDataShow = true;
                });
            },
            //改变页码
            changePage(page){
                this.currPage = page;
                this.getJoined();
            },
            /*page-jump*/
            pageJump(page){
               this.changePage(page);
            },
        },
        watch:{
            isJoined(){
                this.noDataShow = false;
                this.currPage = 1;
                this.getJoined();
            },
            isSearch(){
                this.noDataShow = false;
                this.currPage = 1;
                this.getJoined();
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>

    .fund-table{
        width:100%;
        padding: 0 20px;
        text-align: center;
        thead{
            background: #F4F8FF;
            font-size:16px;
            color:$c_3c3;
        }
        tbody{
            tr{
                &:nth-child(even){
                    background: #F4F8FF;
                }
                font-size: 14px;
                color:$c_666;
            }
        }
        td, th{
            padding: 20px 5px;
            line-height:1.6;
            word-wrap:break-word;
        }
        &.table1{
            .th10,.th11{
                display: table-cell;
            }
            /*.th1{*/
                /*width:140px;*/
            /*}*/
            /*.th2{*/
                /*width:140px;*/
            /*}*/
            /*.th3{*/
                /*width: 140px;*/
            /*}*/
            /*.th4{*/
                /*width:103px;*/
            /*}*/
            /*.th5{*/
                /*width:152px;*/
            /*}*/
            /*.th6{*/
                /*width:140px;*/
            /*}*/
            /*.th7{*/
                /*width:90px;*/
            /*}*/
            /*.th8{*/
                /*width:70px;*/
            /*}*/
            /*.th9{*/
                /*width:70px;*/
            /*}*/
            /*.th10{*/
                /*width:96px;*/
            /*}*/
            .th11{
                width:116px;
            }
        }
        .th10,.th11{
            display: none;
        }
        .th1{
            width:54px;
            a{
                color:$btn_408;
            }
        }
        /*.th2{*/
            /*width:150px;*/
            /*text-align: center;*/

        /*}*/
        /*.th3{*/
            /*width:142px;*/
            /*padding:0 10px;*/
        /*}*/
        /*.th4{*/
            /*width:80px;*/
        /*}*/
        /*.th5{*/
            /*width:98px;*/
            /*padding:0 5px;*/
        /*}*/
        /*.th6{*/
            /*width:90px;*/
            /*padding: 0 8px;*/
        /*}*/
        /*.th7{*/
            /*width:100px;*/
            /*padding: 0 10px;*/
        /*}*/
        /*.th8{*/
            /*!*width:80px;*!*/
            /*padding: 0 5px;*/
        /*}*/
        /*.th9{*/
            /*width:80px;*/
            /*padding: 0 3px;*/
        /*}*/

    }
</style>


// WEBPACK FOOTER //
// src/views/netMana/net_table.vue